/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Session Replay is not essential for security (PIPEDA Principle 3).
 * It must only run when the user has opted into analytics (or a dedicated
 * replay category). Privacy-policy §8.1 still calls this collection essential;
 * policy correction is owned by P05/P06.
 */
export function shouldEnableSentryReplay(options: { isStaging: boolean; analyticsConsent: boolean }): boolean {
  return !options.isStaging && options.analyticsConsent
}
